import { render, staticRenderFns } from "./tiya.vue?vue&type=template&id=93d16042&"
import script from "./tiya.vue?vue&type=script&lang=js&"
export * from "./tiya.vue?vue&type=script&lang=js&"
import style0 from "./tiya.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tiya.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports